// Converts a story's lines into Lesson-compatible exercise objects.
//
// Each line carries a `challenge`:
//   { kind: 'understand' }                            → story-line (presentation only)
//   { kind: 'choose', options: [hrOption, ...] }      → choice exercise
//   { kind: 'cloze',  blankWord, options: [...] }     → cloze exercise
//
// The output flows through Lesson.jsx unchanged — story-line is a new
// case in Body that renders the chat bubble.

function shuffle(arr) {
  const a = arr.slice();
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

function characterById(story, id) {
  return story.characters.find((c) => c.id === id) || { id, emoji: '🗣️' };
}

export function buildStoryExercises(story, sourceLang) {
  const out = [];
  for (const line of story.lines) {
    const character = characterById(story, line.speaker);
    // Synthetic "item" shape so SRS recording and Feedback can pick it up.
    const item = { hr: line.hr, sv: line.sv, en: line.en };

    const baseLine = {
      character,
      hr: line.hr,
      translation: line[sourceLang] || line.sv,
      speakText: line.hr,
      item,
    };

    if (!line.challenge || line.challenge.kind === 'understand') {
      out.push({ type: 'story-line', ...baseLine });
      continue;
    }

    if (line.challenge.kind === 'choose') {
      const options = shuffle(line.challenge.options.slice());
      out.push({
        type: 'choice',
        direction: 'toHR',
        prompt: baseLine.translation,
        correct: line.hr,
        options,
        item,
        speakText: line.hr,
        _storyLine: baseLine,
      });
      continue;
    }

    if (line.challenge.kind === 'cloze') {
      const { blankWord } = line.challenge;
      const promptWithBlank = line.hr.replace(blankWord, '___');
      const options = shuffle(line.challenge.options.slice());
      out.push({
        type: 'cloze',
        promptWithBlank,
        fullSentence: line.hr,
        translation: baseLine.translation,
        correct: blankWord,
        options,
        item,
        speakText: line.hr,
        _storyLine: baseLine,
      });
      continue;
    }
  }
  return out;
}
